import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import injupempGobiernoLogo from "../../img/LogoInjupemp2026.png";
import { openHtmlPrintWindow } from "./reporteriaUtils";

const blankCells = (count) => new Array(count).fill("<td>&nbsp;</td>").join("");
const blankRows = (cells, rows = 1) =>
  new Array(rows).fill(`<tr>${blankCells(cells)}</tr>`).join("");

const buildFichaVaciaHtml = () => `<!doctype html>
<html lang="es">
<head>
  <meta charset="utf-8" />
  <title>Ficha de Afiliacion</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: Arial, sans-serif; margin: 0; background: #AD8401; color: #111; font-size: 11px; }
    .toolbar { position: sticky; top: 0; z-index: 10; background: #fff; padding: 10px 14px; border-bottom: 1px solid #ccc; display: flex; gap: 8px; }
    .toolbar button { padding: 8px 14px; border: 1px solid #888; background: #fff; cursor: pointer; font-weight: 700; }
    .page { width: 216mm; margin: 8px auto; background: #fff; padding: 6mm; box-sizing: border-box; }
    .page + .page { margin-top: 4mm; }
    .header { display: grid; grid-template-columns: 50% 50%; align-items: center; border: 1px solid #111; border-bottom: none; }
    .header img { height: 64px; max-width: 100%; object-fit: contain; margin: 6px 8px; }
    .title { text-align: center; font-size: 22px; font-weight: 700; }
    .section-title { margin: 4px 0 0; padding: 5px 7px; background: #efefef; border: 1px solid #111; font-size: 12px; font-weight: 700; text-transform: uppercase; }
    table { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 11px; }
    th, td { border: 1px solid #111; padding: 3px 5px; vertical-align: top; word-wrap: break-word; line-height: 1.25; }
    td { height: 24px; }
    th { background: #f6f6f6; text-align: left; font-weight: 700; }
    .legal-title { margin: 6px 0 0; padding: 5px; background: #dedede; border: 1px solid #111; font-size: 12px; font-weight: 700; text-align: center; text-transform: uppercase; }
    .legal-box { border: 1px solid #111; border-top: none; padding: 6px; font-size: 11px; line-height: 1.3; }
    .mini-row { display: grid; grid-template-columns: 86px 1fr; border: 1px solid #111; border-top: none; }
    .mini-row .left { border-right: 1px solid #111; font-size: 10px; font-weight: 700; padding: 4px; text-align: center; text-transform: uppercase; line-height: 1.15; word-break: normal; }
    .mini-row .right { padding: 5px 7px; font-size: 11px; line-height: 1.3; }
    .check { display: inline-block; width: 11px; height: 11px; border: 1px solid #111; margin-right: 4px; vertical-align: middle; }
    .fill-line { display: inline-block; border-bottom: 1px solid #111; min-width: 80px; height: 12px; vertical-align: middle; }
    .footer-signatures { margin-top: 24px; display: grid; grid-template-columns: 1fr 1fr; gap: 60px; }
    .footer-signatures .line { border-top: 1px solid #111; padding-top: 3px; text-align: center; font-size: 10px; }
    tr { page-break-inside: avoid; break-inside: avoid; }
    table { page-break-inside: auto; break-inside: auto; }
    .compact-section { margin-top: 6px; }
    @page { size: legal portrait; margin: 8mm; }
    @media print {
      body { background: #fff; }
      .toolbar { display: none; }
      .page { margin: 0; width: auto; min-height: 0; padding: 5mm 3mm; }
      .page + .page { margin-top: 0; }
      .second-page { page-break-before: always; break-before: page; }
    }
  </style>
</head>
<body>
  <div class="toolbar">
    <button onclick="window.print()">Imprimir</button>
    <button onclick="window.close()">Cerrar</button>
  </div>

  <div class="page">
    <div class="header">
      <div><img src="${injupempGobiernoLogo}" alt="Logo" /></div>
      <div class="title">FORMULARIO DE AFILIACIÓN</div>
    </div>

    <div class="section-title">I. DATOS DEL SOLICITANTE</div>
    <table>
      <tr><th>Primer Nombre</th><th>Segundo Nombre</th><th>Primer Apellido</th><th>Segundo Apellido</th></tr>
      ${blankRows(4)}
      <tr><th>Tipo de Identificación</th><th>N° de Documento de Identificación</th><th>Fecha de Nacimiento</th><th></th></tr>
      ${blankRows(4)}
      <tr><th>Lugar de Nacimiento</th><th>Género</th><th>Nacionalidad</th><th>Estado Civil</th></tr>
      ${blankRows(4)}
      <tr><th>Profesión u Oficio / Actividad Económica</th><th>Número de Teléfono Fijo</th><th>Número de Teléfono Celular</th><th></th></tr>
      ${blankRows(4)}
      <tr><th>Correo Electrónico</th><th>Nombre del Conyuge</th><th></th><th></th></tr>
      ${blankRows(4)}
    </table>

    <div class="section-title compact-section">II. INFORMACIÓN RESIDENCIAL</div>
    <table>
      <tr><th>Barrio o Colonia</th><th>Calle o Avenida</th><th>N° de Casa</th><th>Municipio</th></tr>
      ${blankRows(4)}
      <tr><th>Departamento</th><th>Tiempo de Residir</th><th colspan="2">Referencia de Domicilio</th></tr>
      <tr><td>&nbsp;</td><td>&nbsp;</td><td colspan="2">&nbsp;</td></tr>
    </table>

    <div class="section-title compact-section">III. INFORMACIÓN LABORAL</div>
    <table>
      <tr><th>Empleador / Patrono</th><th>Barrio o Colonia</th><th>N° de Casa</th><th>Municipio</th></tr>
      ${blankRows(4)}
      <tr><th>Departamento</th><th>Número de Teléfono</th><th>Referencia de Ubicación</th><th>Giro de Entidad</th></tr>
      ${blankRows(4)}
      <tr><th>Cargo desempeñado</th><th>Antigüedad Laboral</th><th>Ingresos Aproximados (miles de L.)</th><th>Ingresos Aproximados (monto)</th></tr>
      ${blankRows(4)}
    </table>

    <div class="section-title compact-section">OTROS CARGOS PUBLICOS DESEMPEÑADOS EN LOS ULTIMOS CUATRO (4) AÑOS</div>
    <table>
      <tr><th style="width:7%;">No</th><th>Empleador / Patrono</th><th>Cargo Desempeñado</th><th>Actividad o Giro de la Empresa</th></tr>
      ${blankRows(4, 3)}
    </table>

    <div class="section-title compact-section">IV. PATRIMONIO</div>
    <table>
      <tr>
        <th>Vivienda</th>
        <td>Propia</td>
        <td>Alquilada</td>
        <td>Familiar</td>
        <td>Hipoteca</td>
      </tr>
      <tr>
        <th>Posee Vehículo</th>
        <td>Si</td>
        <td>No</td>
        <th>Número de Vehículos</th>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <th>Otros Inmuebles</th>
        <td>Si</td>
        <td>No</td>
        <th>Describa</th>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <th>Otros Ingresos</th>
        <td>Si</td>
        <td>No</td>
        <th>Origen de Otros Ingresos</th>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <th colspan="3">Monto Aproximado de Otros Ingresos (mensuales)</th>
        <td colspan="2">&nbsp;</td>
      </tr>
    </table>

    <div class="section-title compact-section">V. REFERENCIAS LABORALES</div>
    <table>
      <tr><th>Nombre Completo</th><th>Dirección</th><th>N° de Teléfonos</th></tr>
      ${blankRows(3, 2)}
    </table>

    <div class="section-title compact-section">VI. REFERENCIAS PERSONALES</div>
    <table>
      <tr><th>Nombre Completo</th><th>Dirección</th><th>N° de Teléfonos</th></tr>
      ${blankRows(3, 2)}
    </table>

    <div class="section-title compact-section">VII. REFERENCIAS BANCARIAS</div>
    <table>
      <tr><th>Institución Bancaria o Comercial</th><th>N° de Teléfonos</th></tr>
      ${blankRows(2, 1)}
    </table>
  </div>

  <div class="page second-page">
    <div class="section-title">VIII. BENEFICIARIOS</div>
    <table>
      <tr><th style="width:7%;">No</th><th>Nombres</th><th>Apellidos</th><th>N° de Documento</th><th>Parentesco</th></tr>
      ${blankRows(5, 5)}
    </table>


    <div class="legal-title">IX. Persona Expuesta Politicamente (PEP)</div>
    <div class="legal-box">
      <b>DEFINICION:</b> Las Personas Expuestas Politicamente son aquellas que desempeñan o han desempeñado
      funciones publicas destacadas en un pais extranjero o en su propio pais, por ejemplo jefes de Estado, o de
      un gobierno, politicos de alta jerarquia, funcionarios gubernamentales, judiciales o militares de alta
      jerarquia, altos ejecutivos de empresas estatales, funcionarios importantes de partidos politicos. Ej.
      Presidentes de Estado, Titulares de Poderes de Estado e Instituciones Publicas, Alcaldes, Vicealcaldes,
      Regidores, Diputados, Magistrados de la Corte Suprema de Justicia, Miembros Tribunal de Estado Mayor
      Conjunto, entre otros.
    </div>
    <table style="margin-top:0; border-top:none;">
      <tr>
        <td style="width:70%; border-top:none;"><b>¿Es usted una Persona Expuesta Politicamente?</b></td>
        <td style="width:15%; text-align:center; border-top:none;"><span class="check"></span>&nbsp;Si</td>
        <td style="width:15%; text-align:center; border-top:none;"><span class="check"></span>&nbsp;No</td>
      </tr>
    </table>

    <div class="mini-row" style="margin-top:4px;">
      <div class="left">Proposito / uso de la cuenta:</div>
      <div class="right">Ingreso de mis Cotizaciones y Aportaciones</div>
    </div>

    <div class="mini-row">
      <div class="left">X. Declaración</div>
      <div class="right">
        Asi mismo, hago constar que:
        <br />
        1. La informacion detallada en la presente solicitud es verdadera y los documentos adjuntos han sido
        extendidos por autoridad competente.
        <br />
        2. Autorizo al INJUPEMP a verificar los datos e informacion declarada en la presente solicitud.
      </div>
    </div>

    <div class="mini-row">
      <div class="left">XI. Cumplimiento de requisitos</div>
      <div class="right">
        Acompaño a esta solicitud con la documentacion siguiente:
        <br />
        a) Acuerdos de Nombramiento firmada y sellada por las Oficinas de Recursos Humanos
        <span style="float:right"><span class="check"></span></span>
        <br />
        b) Una(1) fotocopia legible de la Tarjeta de Identidad
        <span style="float:right"><span class="check"></span></span>
        <br />
        c) Otros documentos acreditados: detalle:
        <span class="fill-line" style="min-width:260px;"></span>
        <span style="float:right"><span class="check"></span></span>
      </div>
    </div>

    <div class="legal-box" style="margin-top:8px;">
      <b>FUNDAMENTOS DE DERECHO:</b> Fundamento mi petición en el Articulo 80 de la Constitución de la Republica,
      Articulo 2, numeral 1 y 4 de la Ley de INJUPEMP.
    </div>
    <div class="legal-box" style="margin-top:6px;">
      <b>NOTIFICACION:</b>
      <br />
      - Esta solicitud deberá ser presentada personalmente
      <br />
      - Para efectos de notificación, el INJUPEMP utilizará el correo electrónico designado en la presente solicitud.
    </div>
    <p>Firmo en ________________________, a los ______ días del mes de ________________________ de ________, hora ____________.</p>

    <div style="margin-top:100px; text-align:center;">
      <div style="width:320px; margin:0 auto; border-top:1px solid #111; padding-top:4px; text-align:center; font-weight:700; font-size:11px;">
        FIRMA Y HUELLA DEL SOLICITANTE
      </div>
    </div>

    <div class="legal-title" style="margin-top:16px;">XII. Para Uso Exclusivo del INJUPEMP</div>
    <div style="padding:6px 0 0; font-size:10px;">
      <b>Estatus del Participante:</b>
      <span style="margin-left:24px;"><span class="check"></span>Activo</span>
      <span style="margin-left:24px;"><span class="check"></span>Voluntario</span>
      <span style="margin-left:24px;"><span class="check"></span>Suspenso</span>
    </div>
    <br><br><br><br><br><br><br>

    <div class="footer-signatures">
      <div class="line">Nombre del Auxiliar de Registro y Afiliación</div>
      <div class="line">Firma</div>
    </div>
  </div>
</body>
</html>`;

export default function FormatoFichaAfiliacionEnrolamiento() {
  const handleImprimir = () => {
    openHtmlPrintWindow(buildFichaVaciaHtml());
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 2.5, borderRadius: 3, border: "1px solid #dce7f7" }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#19498c", mb: 1 }}
        >
          Formato de Ficha de Afiliación
        </Typography>
        <Typography sx={{ color: "#5a6a80", fontSize: 14, mb: 2 }}>
          Este formato se utiliza para impresión previa y llenado manual por
          parte del participante.
        </Typography>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={handleImprimir}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: "#19498c",
            }}
          >
            Imprimir Formato Vacío
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
